import { RootState } from 'core/store';
import { getCartItemsTracking } from '../../helpers';
import { VWOAnalyticsService } from 'core/services';
import { isTestABVersion } from 'core/use-cases/app/helpers';
import { TRACKING_CURRENCY } from '../../const';

export const concludeOrder = (action: any, prevState: RootState) => {
  const eventName = 'purchase';
  isTestABVersion() && VWOAnalyticsService.dispatchVWOEvent(eventName);
  return {
    event: eventName,
    ecommerce: {
      transaction_id: action.payload?.code,
      shipping: action.payload?.shippingNum,
      currency: TRACKING_CURRENCY,
      value: action.payload?.totalNum,
      coupon: prevState.cart.data?.coupon?.description || '',
      items: getCartItemsTracking(prevState),
    },
  };
};
